import { useTranslations } from 'next-intl'
import { useFormContext } from 'react-hook-form'

import { TAccountForm } from '@/features/update-account'
import {
  useAccountValidation,
  useUpdateGuestContractDepositReturnAccount,
} from '@/features/update-account'
import { Button } from '@/shared/ui'

type Props = {
  contractId: number
  onSuccess?: () => void
}

export const UpdateDepositReturnAccountButton = ({
  contractId,
  onSuccess,
}: Props) => {
  const t = useTranslations('deposit_information')

  const { shouldValidateAccountForm, accountTrigger } = useAccountValidation()

  const { getValues } = useFormContext<TAccountForm>()

  const { updateDepositReturnAccount } =
    useUpdateGuestContractDepositReturnAccount({
      onSuccess,
    })

  const validateForm = async () => {
    let isValid = true

    const hasAccountChanged = shouldValidateAccountForm()

    if (hasAccountChanged) {
      const result = await accountTrigger()

      if (isValid) {
        isValid = result
      }
    }

    return isValid
  }

  const handleClick = async () => {
    const isValid = await validateForm()

    if (!isValid) {
      return
    }

    const formValues = getValues()

    updateDepositReturnAccount(contractId, formValues)
  }

  return (
    <Button
      type="button"
      variant="solid"
      color="primary"
      size="large"
      fullWidth
      onClick={handleClick}
    >
      {t('button.save')}
    </Button>
  )
}
